import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../features/slices/applicationSlice";
import { TFunction } from "i18next";

const useAlerts = ({ translate }: { translate: ((key: string) => string) | TFunction }) => {
    const dispatch = useDispatch();

    const showDeleteStudyAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('newStudyForm.alerts.delete.title'),
                message: translate('newStudyForm.alerts.delete.message'),
                icon: 'info',
                cancelText: translate('newStudyForm.alerts.delete.cancelText'),
                confirmText: translate('newStudyForm.alerts.delete.confirmText'),
                cancelAction: cancelAction,
                confirmAction: confirmAction
            })
        );
    };


    return { showDeleteStudyAlert };
};

export default useAlerts;